import React, { FC, useState, useEffect, MouseEvent } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { Dropzone, IFileObject } from 'transfix-ui/components/Dropzone'
import { useCreateLoadFormContext } from 'apps/fleet-planner/context'
import { IFileCreate } from 'apps/fleet-planner/types/loads'
import { mapDropzoneFiles } from 'apps/fleet-planner/utils/fileUtils'
import { AttachmentList } from '../AttachmentList'

type IBaseControllerProps = ControllerProps<React.ComponentType>
export interface IControlledAttachmentsProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  onSuccess: (message: string) => void
}

interface IUseAttachmentState {
  attachments: IFileCreate[]
}

export const ControlledAttachments: FC<IControlledAttachmentsProps> = ({ onSuccess }) => {
  const { control, setValue } = useCreateLoadFormContext()
  const [load, setLoad] = useState<IUseAttachmentState>({
    attachments: [],
  })

  const changeHandler = (change: Partial<IUseAttachmentState>) => {
    setLoad(prev => ({
      ...prev,
      ...change,
    }))
  }

  const { attachments = [] } = load || {}

  const fileChangeHandler = (files: IFileObject[]) => {
    if (files) {
      const pkgFiles = mapDropzoneFiles(files)
      if (attachments) changeHandler({ attachments: [...attachments, ...pkgFiles] })
      onSuccess('Attachment added.')
    }
  }

  const fileDeleteHandler = (event: MouseEvent<HTMLButtonElement>) => {
    const selectUuid = event?.currentTarget.id
    if (selectUuid) {
      changeHandler({ attachments: attachments?.filter(file => file.uuid !== selectUuid) })
    }
  }

  // Updates state in the create load form context
  useEffect(() => {
    setValue('attachments', attachments)
  }, [attachments, setValue])

  return (
    <>
      <Controller
        name='attachments'
        control={control}
        defaultValue={{}}
        render={({ value }) => <input type='hidden' value={value} />}
      />
      <AttachmentList attachments={attachments} onFileDelete={fileDeleteHandler} />
      <Dropzone
        dropZoneText='Upload your rate confirmation and other files, or drop them here'
        onFileChange={fileChangeHandler}
      />
    </>
  )
}
